/**
 * Global AirMask theme color constants.
 *
 * Import these wherever a thematic color is needed instead of
 * hard-coding hex literals, so that a single change propagates
 * everywhere.
 */

/** Signature AirMask green — primary brand / action color. */
export const AIRMASK_GREEN = '#32CA1D';

/** Deep app-background dark — used as contrast text on green surfaces. */
export const AIRMASK_DARK = '#1A1A1A';

/** Elevated surface gray — used for cards, paper, and code snippet backgrounds. */
export const AIRMASK_SURFACE_GRAY = '#333333';
